import React from 'react';
import background from '../../assets/silver_spinyfin.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoJuvenile extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        subtag="ENDANGERED"
        description="Juvenile Fish"
        paragraph="Many of the world’s marine fish spend their first days or weeks feeding and developing at the ocean surface. The phytoplankton these fish feed on are now comingled with small, indigestible bits of plastic, which in effect starve many developing larvae."
        background={background}
     />
  
  );
 }
}   

export default InfoJuvenile;